/* src/app/components/admin/users/user-edit/user-edit.component.scss */
mat-list-option {
  --mat-list-option___height: 30px;
  --mdc-list-item__primary-text___height: inherit;
  --mdc-list-item__primary-text___overflow-y: auto;
  --mdc-list-item__primary-text___vertical-align: middle;
  --mdc-list-item__primary-text___line-height: 30px;
}
.row {
  padding-bottom: 10px;
}
.title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
}
.link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
}
.mat-mdc-form-field-error {
  margin-top: -10px;
}
.list {
  height: 330px;
  overflow: auto;
  border: 1px solid #949494;
  border-radius: 4px;
  padding-bottom: 8px;
}
.clickable-icon {
  pointer-events: auto;
  cursor: pointer;
}
.readonly-block {
  pointer-events: none;
  cursor: not-allowed;
}
.readonly-block ::ng-deep .mat-pseudo-checkbox-checked {
  background-color: lightgrey !important;
}
:host-context(.dark-theme) .title {
  color: rgba(255, 255, 255, 0.6);
}
:host-context(.dark-theme) .list {
  border: 1px solid #656565;
}
/*# sourceMappingURL=user-edit.component.css.map */
